"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var mockCoverageCatalogList_1 = __importDefault(require("./mockCoverageCatalogList"));
var mockCoverageCatalogResumeList_1 = __importDefault(require("./mockCoverageCatalogResumeList"));
var mockCoverages = __importStar(require("./mockCoverages"));
var products_1 = require("../constants/products");
var mockProductConfiguration_1 = __importDefault(require("./mockProductConfiguration"));
var firstResume = mockCoverageCatalogResumeList_1.default[0];
var mockProductCoverageCatalog = (_a = {},
    _a[products_1.COMPLETE_VEHICLE] = {
        coverages: mockCoverageCatalogList_1.default,
        coverageResumes: mockCoverageCatalogResumeList_1.default,
        configuration: mockProductConfiguration_1.default,
    },
    _a[products_1.THIRD_PARTY_VEHICLE] = {
        coverages: [mockCoverages.regular],
        coverageResumes: [firstResume],
        configuration: mockProductConfiguration_1.default,
    },
    _a);
exports.default = mockProductCoverageCatalog;
//# sourceMappingURL=mockProductCoverageCatalog.js.map